// AUTO-GENERATED from GDKnyttObjectFactory.cs ObjectLookup. Do not edit by hand.
// Maps object id "x,y" -> behaviour/scene name.
export const OBJECT_LOOKUP: Record<string, string> = {
  '0,1': 'SavePoint',
  '0,2': 'Win',
  '0,3': 'PowerItem',
  '0,4': 'PowerItem',
  '0,5': 'PowerItem',
  '0,6': 'PowerItem',
  '0,7': 'PowerItem',
  '0,8': 'PowerItem',
  '0,9': 'PowerItem',
  '0,10': 'PowerItem',
  '0,11': 'NoClimb',
  '0,12': 'GhostMusic',
  '0,13': 'Sticky',
  '0,14': 'Shift',
  '0,15': 'Shift',
  '0,16': 'Shift',
  '0,17': 'Sign',
  '0,18': 'Sign',
  '0,19': 'Sign',
  '0,20': 'Warp',
  '0,21': 'PowerItem',
  '0,22': 'PowerItem',
  '0,23': 'PowerItem',
  '0,24': 'PowerItem',
  '0,25': 'NoJump',
  '0,26': 'EnemyDetector',
  '0,27': 'SecretDetector',
  '0,28': 'SecretDetector',
  '0,29': 'SignArea',
  '0,30': 'SignArea',
  '0,31': 'SignArea',
  '0,32': 'Trigger',
  '0,33': 'Trigger',
  '0,34': 'Trigger',
  '0,35': 'PowerItem',
  '0,36': 'Title',
  '0,37': 'LocalAmbient',
  '0,38': 'LocalAmbient',
  '0,39': 'MuteAmbient',
  '0,40': 'MuteAmbient',
  '0,41': 'NoClimb',
  '0,42': 'SpawnPoint',
  '0,43': 'SpawnPoint',
  '0,44': 'SpawnPoint',
  '0,45': 'DeletePoint',
  '0,46': 'DeletePoint',
  '0,47': 'DeletePoint',
  '0,48': 'AllowHologram',
  '0,49': 'Halt',
  '0,247': 'BlockUser',
  '0,248': 'HoloAutomation',
  '0,249': 'Automation',
  '0,250': 'Automation',
  '0,251': 'Automation',
  '0,252': 'Automation',
  '0,253': 'Automation',
  '0,254': 'Automation',
  '0,255': 'Automation',
  '1,1': 'LiquidPool1',
  '1,2': 'LiquidPool2',
  '1,3': 'Waterfall',
  '1,4': 'Waterfall',
  '1,5': 'LiquidPool5',
  '1,6': 'LiquidPool6',
  '1,7': 'WaterBlock',
  '1,8': 'WaterBlock',
  '1,9': 'WaterBlock',
  '1,10': 'LiquidPool10',
  '1,11': 'WaterBlock',
  '1,12': 'LiquidPool12',
  '1,13': 'LiquidPool13',
  '1,14': 'LiquidPool14',
  '1,15': 'Waterfall',
  '1,16': 'LiquidPool16',
  '1,17': 'WaterBlock',
  '1,18': 'Bubble',
  '1,19': 'LiquidPool19',
  '1,20': 'Waterfall',
  '1,21': 'WaterBlock',
  '1,22': 'LiquidPool22',
  '1,23': 'Waterfall23',
  '1,24': 'WaterBlock',
  '1,25': 'SwimScreen',
  '1,26': 'SwimZoneFull',
  '1,27': 'SwimZoneHalf',
  '2,1': 'Flything',
  '2,2': 'BadFlything',
  '2,3': 'Fly',
  '2,4': 'Fly',
  '2,5': 'BadFlything2',
  '2,6': 'HomingFlything',
  '2,7': 'Flything2',
  '2,8': 'CaveFirefly',
  '2,9': 'YellowBee',
  '2,10': 'RedBee',
  '2,11': 'HomingCircle',
  '2,12': 'HomingRect',
  '2,13': 'RedFirefly',
  '2,14': 'TentacleFlything',
  '2,15': 'PropellerDude',
  '2,16': 'PropellerChild',
  '2,17': 'PropellerChild2',
  '2,18': 'YellowElemental',
  '2,19': 'RedElemental',
  '2,20': 'FlySpike1',
  '2,21': 'FlySpike2',
  '2,22': 'QuadFlything',
  '2,23': 'GreenFirefly',
  '2,24': 'FallPropellerDude',
  '2,25': 'Humbird',
  '2,26': 'Birdie1',
  '2,27': 'Birdie2',
  '2,28': 'Birdie3',
  '2,29': 'SnowBird',
  '2,30': 'CircleBird',
  '2,31': 'BackgroundBird',
  '2,32': 'FastHomingSquare',
  '3,1': 'Muff1',
  '3,2': 'RollerMuff2',
  '3,3': 'Muff3',
  '3,4': 'SpikerMuff4',
  '3,5': 'YellowDog',
  '3,6': 'SpikerMuff6',
  '3,7': 'Muff7',
  '3,8': 'RollerMuff8',
  '3,9': 'Muff9',
  '3,10': 'Muff10',
  '3,11': 'Muff11',
  '3,12': 'Eskimo1',
  '3,13': 'Eskimo2',
  '3,14': 'LookMuff14',
  '3,15': 'Muff15',
  '3,16': 'Muff16',
  '3,17': 'Muff17',
  '3,18': 'Muff18',
  '3,19': 'Muff19',
  '3,20': 'Muff20',
  '3,21': 'BeardGuy',
  '3,22': 'SpikerMuff22',
  '3,23': 'Muff23',
  '3,24': 'Muff24',
  '3,25': 'Ratlike',
  '3,26': 'LookMuff26',
  '3,27': 'ForestDude',
  '3,28': 'Muff28',
  '3,29': 'SkyGirl',
  '3,30': 'Muff30',
  '3,31': 'Muff31',
  '3,32': 'FlyGirl',
  '3,33': 'SpikerMuff33',
  '3,34': 'Muff34',
  '3,35': 'Muff35',
  '3,36': 'Muff36',
  '3,37': 'Baby',
  '3,38': 'LookMuff38',
  '3,39': 'CaveDude',
  '3,40': 'Muff40',
  '3,41': 'LookMuff41',
  '3,42': 'BigCat',
  '3,43': 'SmallCat',
  '3,44': 'Muff44',
  '4,1': 'CircleCrawler',
  '4,2': 'SideCrawler',
  '4,3': 'SixLeg',
  '4,4': 'SixLegChild',
  '4,5': 'SixLegBaby',
  '4,6': 'FloorDropCrawler',
  '4,7': 'CeilingDropCrawler',
  '4,8': 'SlowSideCrawler',
  '4,9': 'BigSpider',
  '4,10': 'LeftStranger',
  '4,11': 'RightStranger',
  '4,12': 'StrangeRunner',
  '4,13': 'SideCrawler2',
  '4,14': 'TriLegSpider',
  '4,15': 'AnotherStrangeRunner',
  '4,16': 'HomingRunner',
  '4,17': 'Hedgehog',
  '4,18': 'ToastMonster',
  '4,19': 'TriShot',
  '4,20': 'FiveShot',
  '4,21': 'RightSuperStranger',
  '4,22': 'LeftSuperStranger',
  '5,1': 'ShadowWitch',
  '5,2': 'ShadowBoy',
  '5,3': 'ShadowGirl',
  '6,1': 'TrapCeiling',
  '6,2': 'LabyrinthSpike',
  '6,3': 'RandomLabyrinthSpike',
  '6,4': 'FastLabyrinthSpike',
  '6,5': 'Eater',
  '6,6': 'TrapFire',
  '6,7': 'DownStuffShooter',
  '6,8': 'SelfDropper',
  '6,9': 'UpStuffShooter',
  '6,10': 'UpSpikes',
  '6,11': 'DownSpikes',
  '6,12': 'LeftSpikes',
  '6,13': 'RightSpikes',
  '6,14': 'UpPermanentSpikes',
  '6,15': 'DownPermanentSpikes',
  '6,16': 'LeftPermanentSpikes',
  '6,17': 'RightPermanentSpikes',
  '7,1': 'BlackLeaf',
  '7,2': 'BlackLeaf',
  '7,3': 'SnowflakeLeaf',
  '7,4': 'SnowflakeLeaf',
  '7,5': 'SunRay',
  '7,6': 'PurpleLeaf',
  '7,7': 'PurpleLeaf',
  '7,8': 'Rain',
  '7,9': 'RaindropObject',
  '7,10': 'GreenLeaf',
  '7,11': 'GreenLeaf',
  '7,12': 'WhiteLeaf',
  '7,13': 'WhiteLeaf',
  '7,14': 'DustLeaf',
  '7,15': 'DustLeaf',
  '7,16': 'Cloud',
  '7,17': 'Muffle',
  '8,1': 'HorizontalConnection',
  '8,2': 'VerticalConnection',
  '8,3': 'LampLeft',
  '8,4': 'LampMid',
  '8,5': 'LampRight',
  '8,6': 'SimpleDecoration',
  '8,7': 'SimpleDecoration',
  '8,8': 'TinyFire',
  '8,9': 'SimpleDecoration',
  '8,10': 'Star',
  '8,11': 'MachinePart1',
  '8,12': 'SimpleDecoration',
  '8,13': 'MachinePart3',
  '8,14': 'MachinePart4',
  '8,15': 'Explosion',
  '8,16': 'FallingStuff',
  '8,17': 'WhiteExplosion',
  '9,1': 'RedTrapFlower',
  '9,2': 'TimedFlower',
  '9,3': 'HomingFlower',
  '9,4': 'AgressiveTrapFlower',
  '9,5': 'SmallTimedFlower',
  '10,1': 'Bouncer1',
  '10,2': 'Bouncer2',
  '10,3': 'Cauldron',
  '10,4': 'SmartBouncer',
  '10,5': 'BouncerEnemy',
  '10,6': 'SmartWalkingBouncer',
  '10,7': 'RandomWalkingBouncer',
  '10,8': 'BouncerGreen',
  '10,9': 'BigFluff',
  '10,10': 'HappyFluff',
  '10,11': 'OldFluff',
  '10,12': 'RegularFluff',
  '10,13': 'TeenageFluff',
  '11,1': 'RedDisk',
  '11,2': 'ShockDisk1',
  '11,3': 'PurpleDisk',
  '11,4': 'PurpleSpikedDisk',
  '11,5': 'RedSpikedDisk',
  '11,6': 'ShockDisk2',
  '11,7': 'AnotherDisk',
  '11,8': 'GreenDisk',
  '11,9': 'ShockDisk3',
  '11,10': 'YellowDisk',
  '11,11': 'YellowDisk2',
  '12,1': 'BoyGhost',
  '12,2': 'GirlGhost',
  '12,3': 'GhostMufs',
  '12,4': 'AnotherGhost',
  '12,5': 'GhostBlock',
  '12,6': 'RoofBlob',
  '12,7': 'AnotherGhost2',
  '12,8': 'GhostMiner',
  '12,9': 'GroundBlob',
  '12,10': 'GhostEater',
  '12,11': 'ClassicGhost',
  '12,12': 'RoofDropper',
  '12,13': 'GhostCrawler',
  '12,14': 'AttackBlock',
  '12,15': 'FlyingBomb',
  '12,16': 'Birdie',
  '12,17': 'NoWall',
  '12,18': 'GhostMarker18',
  '12,19': 'GhostMarker19',
  '12,20': 'GhostMarker20',
  '12,21': 'GhostMarker21',
  '13,1': 'RobotCannon',
  '13,2': 'HomingCannon',
  '13,3': 'LaserRobot',
  '13,4': 'UpCannon',
  '13,5': 'DropstuffRobot',
  '13,6': 'RollerGenerator',
  '13,7': 'Laser',
  '13,8': 'Laser',
  '13,9': 'Laser',
  '13,10': 'Laser',
  '13,11': 'Laser',
  '13,12': 'Laser',
  '13,13': 'FlyBot',
  '13,14': 'DarkHomingCannon',
  '14,1': 'RedJelly',
  '14,2': 'GreenWorm',
  '14,3': 'Snail',
  '14,4': 'OrangeWorm',
  '14,5': 'BouncingRock',
  '14,6': 'SimpleWorm',
  '14,7': 'LargeBouncingRock',
  '14,8': 'HarmlessInsect',
  '14,9': 'DangerousInsect',
  '14,10': 'StationaryRock',
  '14,11': 'InsectWithoutShell',
  '14,12': 'SmileBall',
  '14,13': 'BigRunThing',
  '14,14': 'SmallRunThing',
  '14,15': 'AnotherSnail',
  '14,16': 'FloorSpiker',
  '14,17': 'SuperMarioAI',
  '14,18': 'CeilingSpiker',
  '14,19': 'HiddenSpiker',
  '14,20': 'SpikelessSpiker',
  '14,21': 'SuperShotCeiling',
  '14,22': 'SuperShotFloor',
  '14,23': 'SuperShotLeft',
  '14,24': 'SuperShotRight',
  '15,1': 'Block1',
  '15,2': 'Block2',
  '15,3': 'Block3',
  '15,4': 'Block4',
  '15,5': 'Updraft',
  '15,6': 'ProximityBlock',
  '15,7': 'ProximityBlock',
  '15,8': 'FalseBlock',
  '15,9': 'FalseBlock9',
  '15,10': 'FalseBlock10',
  '15,11': 'FalseBlock11',
  '15,12': 'LockBlock12',
  '15,13': 'Password',
  '15,14': 'Password',
  '15,15': 'Password',
  '15,16': 'Password',
  '15,17': 'Password',
  '15,18': 'Password',
  '15,19': 'Password',
  '15,20': 'Password',
  '15,21': 'Password',
  '15,22': 'ClearBlock',
  '15,23': 'LockBlockHorizontal',
  '15,24': 'LockBlockVertical',
  '15,25': 'FadeBlock',
  '15,26': 'HoldButton',
  '15,27': 'RedDoor',
  '15,28': 'YellowDoor',
  '15,29': 'BlueDoor',
  '15,30': 'PurpleDoor',
  '15,31': 'CollectionDoor1',
  '15,32': 'CollectionDoor5',
  '15,33': 'CollectionDoor10',
  '15,34': 'CollectionDoor20',
  '15,35': 'CollectionDoor40',
  '15,36': 'CollectionDoor50',
  '15,37': 'Crumble37',
  '15,38': 'Crumble38',
  '16,1': 'Spring',
  '16,2': 'DeathZoneTop',
  '16,3': 'DeathZoneBottom',
  '16,4': 'DeathZoneRight',
  '16,5': 'DeathZoneLeft',
  '16,6': 'DeathZone',
  '16,7': 'DeathZoneMiddleH',
  '16,8': 'DeathZoneMiddleV',
  '16,9': 'DeathZoneHalfRight',
  '16,10': 'DeathZoneHalfUp',
  '16,11': 'DeathZoneHalfLeft',
  '16,12': 'DeathZoneHalfDown',
  '16,13': 'InvisibleBarrier',
  '16,14': 'InvisibleBlock',
  '16,15': 'InvisibleSlopeLeft',
  '16,16': 'InvisibleSlopeRight',
  '16,17': 'Barrier',
  '16,18': 'FlyersBarrier',
  '16,19': 'AdditionalBarrier19',
  '16,20': 'AdditionalBarrier20',
  '16,21': 'AdditionalSlope21',
  '16,22': 'AdditionalSlope22',
  '16,23': 'AdditionalSlope23',
  '16,24': 'AdditionalSlope24',
  '16,25': 'AdditionalBarrier25',
  '16,26': 'AdditionalBarrier26',
  '16,27': 'AdditionalBarrier27',
  '16,28': 'AdditionalBarrier28',
  '16,29': 'OneWayPlatform',
  '16,30': 'TwoWayPlatform',
  '17,1': 'DarkRandomizer',
  '17,2': 'SmallSpider',
  '17,3': 'WaterEye',
  '17,4': 'MadSpider',
  '17,5': 'CeilingMadSpider',
  '17,6': 'Flything',
  '17,7': 'Ninja',
  '17,8': 'RightNinja',
  '17,9': 'LeftNinja',
  '17,10': 'FloorSpiker',
  '17,11': 'LeftSpiker',
  '17,12': 'RightSpiker',
  '18,1': 'Fish1',
  '18,2': 'Fish2',
  '18,3': 'Fish3',
  '18,4': 'Fish4',
  '18,5': 'Fish5',
  '18,6': 'WaterMonster',
  '19,1': 'Collectable',
  '19,2': 'Collectable',
  '19,3': 'Collectable',
  '19,4': 'Collectable',
  '19,5': 'Collectable',
  '19,6': 'Collectable',
  '19,7': 'Collectable',
  '19,8': 'Collectable',
  '19,9': 'Collectable',
  '19,10': 'Collectable',
  '19,11': 'Collectable',
  '19,12': 'Collectable',
  '19,13': 'Collectable',
  '19,14': 'Collectable',
  '19,15': 'Collectable',
  '19,16': 'Collectable',
  '19,17': 'Collectable',
  '19,18': 'Collectable',
  '19,19': 'Collectable',
  '19,20': 'Collectable',
  '19,21': 'Collectable',
  '19,22': 'Collectable',
  '19,23': 'Collectable',
  '19,24': 'Collectable',
  '19,25': 'Collectable',
  '19,26': 'Collectable',
  '19,27': 'Collectable',
  '19,28': 'Collectable',
  '19,29': 'Collectable',
  '19,30': 'Collectable',
  '19,31': 'Collectable',
  '19,32': 'Collectable',
  '19,33': 'Collectable',
  '19,34': 'Collectable',
  '19,35': 'Collectable',
  '19,36': 'Collectable',
  '19,37': 'Collectable',
  '19,38': 'Collectable',
  '19,39': 'Collectable',
  '19,40': 'Collectable',
  '19,41': 'Collectable',
  '19,42': 'Collectable',
  '19,43': 'Collectable',
  '19,44': 'Collectable',
  '19,45': 'Collectable',
  '19,46': 'Collectable',
  '19,47': 'Collectable',
  '19,48': 'Collectable',
  '19,49': 'Collectable',
  '19,50': 'Collectable',
  '19,51': 'Coin',
  '19,52': 'Coin',
  '19,53': 'Coin',
  '19,54': 'Coin',
  '19,55': 'Coin',
  '19,56': 'Coin',
  '19,57': 'Coin',
  '19,58': 'Coin',
  '19,59': 'Coin',
  '19,60': 'Coin',
  '19,61': 'Coin',
  '19,62': 'Coin',
  '19,63': 'Coin',
  '19,64': 'Coin',
  '19,65': 'Coin',
  '19,66': 'Coin',
  '19,67': 'Coin',
  '19,68': 'Coin',
  '19,69': 'Coin',
  '19,70': 'Coin',
  '19,71': 'Coin',
  '19,72': 'Coin',
  '19,73': 'Coin',
  '19,74': 'Coin',
  '19,75': 'Coin',
  '19,76': 'Coin',
  '19,77': 'Coin',
  '19,78': 'Coin',
  '19,79': 'Coin',
  '19,80': 'Coin',
  '19,81': 'Coin',
  '19,82': 'Coin',
  '19,83': 'Coin',
  '19,84': 'Coin',
  '19,85': 'Coin',
  '19,86': 'Coin',
  '19,87': 'Coin',
  '19,88': 'Coin',
  '19,89': 'Coin',
  '19,90': 'Coin',
  '19,91': 'Coin',
  '19,92': 'Coin',
  '19,93': 'Coin',
  '19,94': 'Coin',
  '19,95': 'Coin',
  '19,96': 'Coin',
  '19,97': 'Coin',
  '19,98': 'Coin',
  '19,99': 'Coin',
  '19,100': 'Coin',
  '19,101': 'Coin',
  '19,102': 'Coin',
  '19,103': 'Coin',
  '19,104': 'Coin',
  '19,105': 'Coin',
  '19,106': 'Coin',
  '19,107': 'Coin',
  '19,108': 'Coin',
  '19,109': 'Coin',
  '19,110': 'Coin',
  '19,111': 'Coin',
  '19,112': 'Coin',
  '19,113': 'Coin',
  '19,114': 'Coin',
  '19,115': 'Coin',
  '19,116': 'Coin',
  '19,117': 'Coin',
  '19,118': 'Coin',
  '19,119': 'Coin',
  '19,120': 'Coin',
  '19,121': 'Coin',
  '19,122': 'Coin',
  '19,123': 'Coin',
  '19,124': 'Coin',
  '19,125': 'Coin',
  '19,126': 'Coin',
  '19,127': 'Coin',
  '19,128': 'Coin',
  '19,129': 'Coin',
  '19,130': 'Coin',
  '19,131': 'Coin',
  '19,132': 'Coin',
  '19,133': 'Coin',
  '19,134': 'Coin',
  '19,135': 'Coin',
  '19,136': 'Coin',
  '19,137': 'Coin',
  '19,138': 'Coin',
  '19,139': 'Coin',
  '19,140': 'Coin',
  '19,141': 'Coin',
  '19,142': 'Coin',
  '19,143': 'Coin',
  '19,144': 'Coin',
  '19,145': 'Coin',
  '19,146': 'Coin',
  '19,147': 'Coin',
  '19,148': 'Coin',
  '19,149': 'Coin',
  '19,150': 'Coin',
  '19,151': 'Artifact',
  '19,152': 'Artifact',
  '19,153': 'Artifact',
  '19,154': 'Artifact',
  '19,155': 'Artifact',
  '19,156': 'Artifact',
  '19,157': 'Artifact',
  '19,158': 'Artifact',
  '19,159': 'Artifact',
  '19,160': 'Artifact',
  '19,161': 'Artifact',
  '19,162': 'Artifact',
  '19,163': 'Artifact',
  '19,164': 'Artifact',
  '19,165': 'Artifact',
  '19,166': 'Artifact',
  '19,167': 'Artifact',
  '19,168': 'Artifact',
  '19,169': 'Artifact',
  '19,170': 'Artifact',
  '19,171': 'Artifact',
  '19,172': 'Artifact',
  '19,173': 'Artifact',
  '19,174': 'Artifact',
  '19,175': 'Artifact',
  '19,176': 'Artifact',
  '19,177': 'Artifact',
  '19,178': 'Artifact',
  '19,179': 'Artifact',
  '19,180': 'Artifact',
  '19,181': 'Artifact',
  '19,182': 'Artifact',
  '19,183': 'Artifact',
  '19,184': 'Artifact',
  '19,185': 'Artifact',
  '19,186': 'Artifact',
  '19,187': 'Artifact',
  '19,188': 'Artifact',
  '19,189': 'Artifact',
  '19,190': 'Artifact',
  '19,191': 'Artifact',
  '19,192': 'Artifact',
  '19,193': 'Artifact',
  '19,194': 'Artifact',
  '19,195': 'Artifact',
  '19,196': 'Artifact',
  '19,197': 'Artifact',
  '19,198': 'Artifact',
  '19,199': 'Artifact',
};

export function objectName(x: number, y: number): string | null {
  if (x === 254) return 'CustomObjectB';
  if (x === 255) return 'CustomObject';
  return OBJECT_LOOKUP[`${x},${y}`] ?? null;
}
